import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-1" }
const _hoisted_2 = { class: "relative flex items-center" }
const _hoisted_3 = {
  key: 0,
  class: "text-faded-foreground flex items-center justify-between gap-1 text-[10px]"
}

import { computed } from 'vue';
    import ThousandSeparatorInput from '@/components/ThousandSeparatorInput.vue';
    import type { Row, Table } from '@tanstack/vue-table';
    import type { VatSubmission } from '@/types';
    import { useI18n } from 'vue-i18n';
    import { formatCurrency } from '@/utils/helpers';
    import { useVatStore } from '@/stores/vat';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'VatTableInput',
  props: /*@__PURE__*/_mergeModels({
    table: {},
    row: {},
    columnId: {}
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

    const { t } = useI18n();

    const vatStore = useVatStore();

    const props = __props;

    const model = _useModel<number | null>(__props, "modelValue");

    const isDeadlinePassed = computed(() => {
        if (!props.row.original.deadline) {
            return false;
        }

        const deadline = new Date(props.row.original.deadline);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        deadline.setHours(0, 0, 0, 0);

        return deadline < today;
    });

    const isDisabled = computed(() => {
        return (
            isDeadlinePassed.value ||
            (props.row.original.status !== 'draft' && !props.row.original._is_editing)
        );
    });

    const handleBlur = () => {
        if (!isDisabled.value) {
            props.table.options.meta?.updateData?.(props.row, props.columnId, model.value);
        }
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ThousandSeparatorInput, {
        modelValue: model.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
        "with-decimals": "",
        placeholder: _unref(t)('vat.specify_amount'),
        class: "min-w-52 pr-8",
        onBlur: handleBlur,
        disabled: isDisabled.value
      }, null, 8, ["modelValue", "placeholder", "disabled"]),
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "pointer-events-none absolute right-2" }, "Kr.", -1))
    ]),
    (_unref(vatStore).showPreviousSubmission && _ctx.row.original.previous_submission)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString(_unref(formatCurrency)(_ctx.row.original.previous_submission[props.columnId] as number)), 1),
          _createElementVNode("span", null, _toDisplayString(_unref(t)('vat.previous_submission')), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})